import React, { Component } from 'react';
import { connect } from 'react-redux';
import MoviesResults from "../../movieresults/movieresults.component";
import {getRecentMoviesPage} from '../../../../SHARED/actions/movies.actions';

class MovieResultsContainerRecentMovies extends Component {
    
    componentWillMount(){
        this.props.getRecentMoviesPage();
    }
    
    getCards() {
        if(this.props.recentMovies.rows){
            return this.props.recentMovies
        }
    }

    render() {
        return (
            <div className="movie-results-container">
                <MoviesResults cards={this.getCards()} component="recentMovies"/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    recentMovies: state.movies.recentMoviesPage
});
export default connect(mapStateToProps, {getRecentMoviesPage})(MovieResultsContainerRecentMovies);



// WEBPACK FOOTER //
// ./src/FO/components/recentmovies/containers/movieresultscontainer.component.js